import React from "react";
import GoogleIcon from "./icons/GoogleIcon";

interface LoginButtonProps {
  onLogin: () => void;
}

const LoginButton: React.FC<LoginButtonProps> = ({ onLogin }) => {
  return (
    <button
      onClick={onLogin}
      className="flex items-center justify-center gap-3 w-full max-w-xs mx-auto bg-navy-deep/50 text-text-primary font-semibold py-2 px-4 border border-border-strong rounded transition-all duration-200 hover:border-rose-muted hover:bg-navy/50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-navy-darkest focus:ring-rose-accent"
      aria-label="Sign in with Google"
    >
      <GoogleIcon className="h-6 w-6" />
      <span>Sign in with Google</span>
    </button>
  );
};

export default LoginButton;
